// extracted by mini-css-extract-plugin
export var active = "_tp-1";
export var circle = "_tp-0";
export var completed = "_tp-2";
export var connector = "_tp-4";
export var connectorCompleted = "_tp-7";
export var connectorSpacer = "_tp-5";
export var iconStrokeOverride = "_tp-8";
export var labelContainer = "_tp-6";
export var pending = "_tp-3";